// @ts-nocheck

import { type StateType } from '../../../../states';
import { type Selector } from '../../../../types/selectors';
import { type BoomStepId } from '../../types/steps';
import { selectBoomState } from '../boom/boomPrimary.selector';

const emptyArray: [] = [];

export const selectBoomStepsOrderState: Selector<Array<BoomStepId>> = (state: StateType) =>
  selectBoomState(state)?.stepsOrder ?? emptyArray;
